import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-boardsign-info',
  templateUrl: './boardsign-info.component.html',
  styleUrls: ['./boardsign-info.component.scss']
})
export class BoardsignInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
